import { render, staticRenderFns } from "./GroupGoodsList.vue?vue&type=template&id=51566fb6"
import script from "./GroupGoodsList.vue?vue&type=script&lang=js"
export * from "./GroupGoodsList.vue?vue&type=script&lang=js"
import style0 from "./GroupGoodsList.vue?vue&type=style&index=0&id=51566fb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports